import { render, staticRenderFns } from "./DownloadIcon.vue?vue&type=template&id=1ecc8d45&"
import script from "./DownloadIcon.vue?vue&type=script&lang=ts&"
export * from "./DownloadIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports